import { useIsCheckin } from '../../../../context';
import { checkoutCommonSelectors, checkinCommonSelectors } from '../model/selectors.common';
export function useOrderSelectors() {
    const isCheckin = useIsCheckin();
    return isCheckin ? checkinCommonSelectors : checkoutCommonSelectors;
}
